import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG } from "./actionTypes"

export const editProfile = (user: any) => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = (msg: any) => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = (error: any) => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = (error?: any) => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}
